var base = [{
  path: '/ownspace',
  title: '基本信息',
  name: 'ownspace',
  meta: {
    title: '基本信息',
    hideInMenu: true,
    notCache: true
  },
  component: function component() {
    return import('@/view/user/own-space.vue');
  }
}, {
  path: '/editPass',
  title: '修改密码',
  name: 'editPass',
  meta: {
    hideInMenu: true,
    title: '修改密码',
    notCache: true
  },
  component: function component() {
    return import('@/view/user/editPass.vue');
  }
}, {
  path: '/certification',
  title: '实名认证',
  name: 'certification',
  meta: {
    title: '实名认证',
    hideInMenu: true,
    notCache: true
  },
  component: function component() {
    return import('@/view/user/certification.vue');
  }
}, {
  path: '/maintenanceReport/:id/:shStatus',
  title: '查看维保',
  name: 'maintenanceReport',
  meta: {
    title: '查看维保',
    hideInMenu: true,
    notCache: true
  },
  component: function component() {
    return import('@/view/console/maintenance/components/reviewResult.vue');
  }
}];
export default base;